module.exports = __webpack_public_path__ + "static/media/avatar_user.c05614aa.webp";